var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,75.294118%,17.647059%)",
      fillOpacity: 1
    },
    d: "M 23.765625 9.652344 L 22.800781 9.652344 L 22.800781 9.597656 L 12 9.597656 L 12 14.402344 L 18.78125 14.402344 C 17.792969 17.195312 15.132812 19.199219 12 19.199219 C 8.023438 19.199219 4.800781 15.976562 4.800781 12 C 4.800781 8.023438 8.023438 4.800781 12 4.800781 C 13.835938 4.800781 15.503906 5.492188 16.777344 6.621094 L 20.171875 3.230469 C 18.027344 1.230469 15.160156 0 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 11.195312 23.917969 10.410156 23.765625 9.652344 Z M 23.765625 9.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,22.352941%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 1.382812 6.414062 L 5.324219 9.308594 C 6.394531 6.664062 8.976562 4.800781 12 4.800781 C 13.835938 4.800781 15.503906 5.492188 16.777344 6.621094 L 20.171875 3.230469 C 18.027344 1.230469 15.160156 0 12 0 C 7.390625 0 3.394531 2.601562 1.382812 6.414062 Z M 1.382812 6.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.803922%,68.627451%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 12 24 C 15.097656 24 17.917969 22.816406 20.042969 20.886719 L 16.332031 17.742188 C 15.128906 18.65625 13.628906 19.199219 12 19.199219 C 8.878906 19.199219 6.230469 17.210938 5.230469 14.433594 L 1.316406 17.449219 C 3.300781 21.332031 7.335938 24 12 24 Z M 12 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,39.607843%,75.294118%)",
      fillOpacity: 1
    },
    d: "M 23.765625 9.652344 L 23.757812 9.597656 L 12 9.597656 L 12 14.402344 L 18.78125 14.402344 C 18.308594 15.742188 17.441406 16.898438 16.332031 17.742188 L 20.042969 20.886719 C 19.785156 21.121094 24 18 24 12 C 24 11.195312 23.917969 10.410156 23.765625 9.652344 Z M 23.765625 9.652344 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.044f43098ab1677e455c1e419c45b942.svg";
export { ForwardRef as ReactComponent };